module.exports = __webpack_public_path__ + "d24955d3.svg";